The pagination metadata for this page of webhook subscription replays.

Disclaimer:

- The `hasPreviousPage` field will always be false when paginating by `first`.
- The `hasNextPage` field will always be false when paginating by `last`.

To discern whether a next/previous page exists in these conditions, an additional request will need to be made to retrieve the next/previous page.
